import Constants from "../components/lib/Constants";

export const gameActions = {
  changeStatus,
  start,
  addTime,
  updateTimer
};

function start() {
  return dispatch => {
    dispatch(startGame());
  };
}
function updateTimer (time){
    return dispatch => {
        dispatch(updateTime(time));
    };
}

function addTime() {
  return dispatch => {
    dispatch(add());
  };
}

function changeStatus(status) {
  return dispatch => {
    dispatch(changeGameStatus(status));
  };
}
function updateTime(time) {
  return {
    type: Constants.REQUEST_UPDATE_TIMER,
    payload: time
  };
}
function startGame() {
  return {
    type: Constants.REQUEST_START_GAME
  };
}
function add() {
  return {
    type: Constants.REQUEST_ADD_GAME_TIME
  };
}

function changeGameStatus(status) {
  return {
    type: Constants.REQUEST_GAME_STATUS,
    payload:status
  };
}



// WEBPACK FOOTER //
// ./src/actions/gameActions.js